import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
import Swiper from '../js/vendor/swiper/swiper.min';
import initAdvisorReviews from './scripts/advisor-reviews';
import '../styles/page-city-v6.scss';

// Läs mer >> button

//Service package slider
let packageSwiper = new Swiper('.package-slider--default', {
	slidesPerView: 4,
	spaceBetween: 15,
	keyboard: false,
	allowTouchMove: false,
	mousewheel: false,
	simulateTouch:false,
	passiveListeners: false,
	breakpoints: {
		1200: {
			slidesPerView: 4,
			spaceBetween: 15,
			keyboard: false,
			allowTouchMove: false,
			mousewheel: false,
			simulateTouch:false,
		},
		1024: {
			slidesPerView: 2.6,
			spaceBetween: 15,
			slidesOffsetBefore:25,
			slidesOffsetAfter:25,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
		},
		719: {
			slidesPerView: 1.5,
			spaceBetween: 15,
			slidesOffsetBefore:25,
			slidesOffsetAfter:25,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
		}
	},
	pagination: {
		el: ".package-slider-pagination--default",
		clickable: 'true'
	}
});

let packageSwiperExp = new Swiper('.package-slider--exp', {
	slidesPerView: 4,
	spaceBetween: 15,
	keyboard: false,
	allowTouchMove: false,
	mousewheel: false,
	simulateTouch:false,
	passiveListeners: false,
	breakpoints: {
		1200: {
			slidesPerView: 4,
			spaceBetween: 15,
			keyboard: false,
			allowTouchMove: false,
			mousewheel: false,
			simulateTouch:false,
		},
		1024: {
			slidesPerView: 2.6,
			spaceBetween: 15,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
		},
		719: {
			slidesPerView: 1.3,
			spaceBetween: 15,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
			slidesOffsetBefore:25,
			slidesOffsetAfter:25,
		}
	},
	pagination: {
		el: ".package-slider-pagination--exp",
		clickable: 'true'
	}
});

let chapellSwiper = new Swiper('#chapel', {
	lazy: {
		checkInView: true,
		loadOnTransitionStart: true
	},
	updateOnWindowResize: true,
	slidesPerView: 3,
	spaceBetween:0,
	grabCursor: true,
	keyboard: true,
	allowTouchMove: true,
	mousewheel: false,
	simulateTouch:true,
	passiveListeners: false,
	observer: true,
	observeParents: true,
	navigation: {
		nextEl: '.swiper-button-next-location',
		prevEl: '.swiper-button-prev-location',
	},
	breakpoints: {
		1200: {
			slidesPerView: 3,
			spaceBetween:0,
			grabCursor: true,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
		},
		719: {
			slidesPerView: 1,
			spaceBetween:0,
			grabCursor: true,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
			centeredSlides:true,
		}
	}
});

let cemeterySwiper = new Swiper('#cemetery', {
	lazy: {
		checkInView: true,
		loadOnTransitionStart: true
	},
	updateOnWindowResize: true,
	slidesPerView: 3,
	spaceBetween:0,
	grabCursor: true,
	keyboard: true,
	allowTouchMove: true,
	mousewheel: false,
	simulateTouch:true,
	passiveListeners: false,
	observer: true,
	observeParents: true,
	navigation: {
		nextEl: '.swiper-button-next-location',
		prevEl: '.swiper-button-prev-location',
	},
	breakpoints: {
		1200: {
			slidesPerView: 3,
			spaceBetween:0,
			grabCursor: true,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
		},
		719: {
			slidesPerView: 1,
			spaceBetween:0,
			grabCursor: true,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
			centeredSlides:true,
		}
	}
});

jQuery(function ($) {
	if( $('.hidden-content__button').length ) {
		$('.hidden-content__button').click(function () {
			let x = $(this).parent().prev('.hidden-content');

			if (x.css('display') === "none") {
				x.css('display', 'block');
				$(this).text("Stäng") ;
				/*jQuery('html, body').animate({
					scrollTop: jQuery(x).offset().top - 140
				}, 1000);*/
			} else {
				x.css('display', 'none');
				$(this).text("Läs mer");
				/*jQuery('html, body').animate({
					scrollTop: jQuery($(this)).offset().top - 140
				}, 1000);*/
			}
		});
	}

	$('#locationType').on('change', function (e) {
		$('#' + $(this).val() + '-tab').tab('show');
	});

	// Läs mer >> button for SEO-test on 19 city pages
	if( $('#lasMer').length ) {
		$('#lasMer').click(function () {
			// $(this).prev('.wrap__readmore').removeClass("wrap__readmore");
			$(this).prev('.wrap__readmore').css("max-height", "max-content");
			$(this).prev('.wrap__readmore').addClass("expanded");
			// $(this).parent('.dual-card__left').removeClass("readmore");
			$(this).parent('.dual-card__left').css("max-height", "max-content");
			$(this).hide();
		});
	}
});

// Advisor review slider (parts/advisor-reviews-slider.php)
initAdvisorReviews();
